// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".big-text-container[data-v-1aa81892]{max-width:900px}p>span[data-v-1aa81892]{font-size:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
